import { VideoDetail } from '@fs/zion-rootstech'

const VideoMutation = `
  ${VideoDetail}
  fragment VideoMutation on VideoMutation {
    result {
      ...VideoDetail
    }
  }
`
export default VideoMutation
